var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full",class:[
    _vm.infoOpen ? 'cross' : 'dot',
    _vm.forgroundColor ? 'text-white' : 'text-black'
  ],attrs:{"id":"app","data-colour":_vm.colourIndex}},[_c('Home'),_c('CursorDot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }